jQuery(document).ready(function() {

// Custom JS functions



    if($('.hero-bkg-slider, .absolute-slider')[0]){
        $('.hero-bkg-slider, .absolute-slider').slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 1500,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            pauseOnHover:false,
            pauseOnFocus:false,
            autoplaySpeed: 8000,
        });
    }

    var testimonial = $('.h1-testimonial-active');
    if(testimonial.length){
        testimonial.slick({
            dots: false,
            infinite: true,
            speed: 1000,
            autoplay:false,
            arrows: false,
            prevArrow: '<button type="button" class="slick-prev"><i class="ti-angle-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="ti-angle-right"></i></button>',
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                        arrow:false,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows:false,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows:false,
                    },
                },
            ],
        });
    }
// Open Modal From URL
$('.announcementModal').attr('data-target','#announcementModal').attr('data-toggle', 'modal');

});



// WEBPACK FOOTER //
// ./scripts/mta.js